<div class="background-dev-espace" [ngStyle]="{'min-height': '100%'}">
  @if (loader) {
    <div class="slider">
      <div class="line"></div>
      <div class="subline inc"></div>
      <div class="subline dec"></div>
    </div>
  }

  @if (authService.userConnected && authService.userConnected['inscriptionComplete']) {
    <app-navigation id="appNavigation"
    ></app-navigation>
  }
  <router-outlet></router-outlet>

  @if (maintenanceCheckService.pinnedMaintenanceTask) {
    <div id="bandeau-maintenance">
      {{'front.maintenance.operationEnCours' | translate}}
      {{ maintenanceCheckService.pinnedMaintenanceTask.estimatedEndDatetime | date : 'dd/MM/yyyy HH:mm' }}
      <a (click)="maintenanceCheckService.openInfos(maintenanceCheckService.pinnedMaintenanceTask)">
        {{'general.savoirPlus' | translate}}
      </a>
    </div>
  }

  @if (environment.environmentName !== 'PROD') {
    <div id="environment-badge" class="environment-{{ environment.environmentName }}">
      {{ environment.environmentName }}
    </div>
  }
</div>
